import { FullEventFragment } from '@/generated/graphql';
import { createContext, Dispatch, useContext } from 'react';
import { ActionType } from './actions';
import { AdminEngagementState } from './reducer';
import { EditorSaveStatus } from '@/engagements/trivia/admin/saveStatus';

type AdminEngagementContextType = {
  dispatch: Dispatch<ActionType>;
  state: AdminEngagementState;
  event: FullEventFragment;
  saveStatus: EditorSaveStatus;
};

export const AdminEngagementContext = createContext<AdminEngagementContextType>(
  {
    dispatch: () => {},
    state: {} as AdminEngagementState,
    event: {} as FullEventFragment,
    saveStatus: { kind: 'saved' },
  },
);

export const useAdminEngagementContext = () => {
  const context = useContext(AdminEngagementContext);
  if (!context) {
    throw new Error(
      'useAdminEngagementContext must be used within a AdminEngagementProvider',
    );
  }
  return context;
};
